import { useState } from "react";

export enum LocalStorageKeys {
  user = "user",
}

export const useLocalStorage = (
  key: LocalStorageKeys,
  initialValue: any,
  useSearch = false
) => {
  const getItemBySearch = (search: any) => {
    let values = Object.keys(localStorage)
      .filter((key) => key.includes(search))
      .map((key) => localStorage[key]);
    return values;
  };

  const [value, setStateValue] = useState(() => {
    try {
      const item: any = useSearch
        ? getItemBySearch(key)
        : window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.log(error);
      return initialValue;
    }
  });

  const setValue = (newValue: any) => {
    try {
      const updatedValue =
        typeof newValue === "function" ? newValue(value) : newValue;
      setStateValue(updatedValue);
      window.localStorage.setItem(key, JSON.stringify(updatedValue));
    } catch (error) {
      console.log(error);
    }
  };

  const updateNestedValue = (path: string[], newValue: any) => {
    try {
      const updatedObject = { ...value };
      let current = updatedObject;
      
      // Create nested objects if they don't exist
      for (let i = 0; i < path.length - 1; i++) {
        if (!current[path[i]]) {
          current[path[i]] = {};
        }
        current = current[path[i]];
      }
      
      current[path[path.length - 1]] = newValue;
      setValue(updatedObject);
    } catch (error) {
      console.error(error);
    }
  };

  const deleteValue = () => {
    try {
      window.localStorage.removeItem(key);
      setStateValue(undefined);
    } catch (error) {
      console.error(error);
    }
  };

  return [value, setValue, deleteValue, getItemBySearch, updateNestedValue];
};
